import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import PartnerHeader from './PartnerHeader';
import PartnerSidebar from './PartnerSidebar';
import { DeactivatedAccountBanner } from '@/components/common/DeactivatedAccountBanner';
import AIChatBubble from '@/components/AIChatBubble';

const PartnerLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <PartnerHeader onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
      <PartnerSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <main className="md:pl-64">
        <div className="p-4 md:p-6">
          <DeactivatedAccountBanner />
          <Outlet />
        </div>
      </main>
      <AIChatBubble portalType="partner" />
    </div>
  );
};

export default PartnerLayout;
